// src/pages/ActivitiesPage.js
import React, { useContext, useEffect } from "react";
import { ContentContext } from "../context/ContentProvider";
import { Helmet } from "react-helmet";
import "./Activities.css";

function Activities() {
  const { content } = useContext(ContentContext);
  

  // Debug: log whenever content changes
  useEffect(() => {
    console.log("Updated activities content:", content);
  }, [content]);

  return (
    <>
      <Helmet>
        <title>Activities | Londonhouse </title>
      </Helmet>
      <div className="activities-page-container">
        <div className="activities-content">
          <h1>Activities</h1>
          <div
            className="activities-text"
            style={{
              color: content.activitiesStyle?.color || "#000000",
              fontWeight: content.activitiesStyle?.bold ? "bold" : "normal",
              fontStyle: content.activitiesStyle?.italic ? "italic" : "normal",
              textAlign: "center",
              whiteSpace: "pre-wrap",
            }}
          >
            {content.activitiesText || "No activities content available."}
          </div>
        </div>
      </div>
    </>
  );
}

export default Activities;
